// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/background-rect.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body, html {
  width: 100%;
  height: 100%;
  font-family: 'Roboto', sans-serif;
}

#root {
  height: 100%;
}

.wrapper {
  width: 100%;
  height: calc(100% - 62px);
  min-height: 100vh;
}

.container {
  width: 100%;
  height: 100%;
  min-height: 100vh;
}

.btn {
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  border-radius: 5px;
  background: #61AC47;
  padding: 10px 25px;
  border: none;
  color: #fff;
  cursor: pointer;
  outline: none;
}

.btn:active, .btn:focus {
  outline: none;
  -webkit-user-select: none;
          user-select: none;
}

.btn-inverted {     
  background: #fff;
  color: #1f5d23;
}

.btn-inverted-bordered {
  border: 1px solid #1f5d23;
  border-radius: 5px;
}

.btn-dark {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  text-decoration: none;
}

button:disabled {
  cursor: not-allowed;
  opacity: .5;
}

.error {
  font-size: 12px;
  line-height: 14px;
  color: #D0021B;
}

.displayNone {
  display: none !important;
}

.visibilityHidden {
  visibility: hidden;
  /* z-index: -1; */
}

.minwidth-200 {
  display: block;
  width: 250px;
  margin: 0px auto;
  text-align: center;
  position: relative;
}

#footer{
  /* position: fixed; */
  /* position:sticky;
  bottom: 5px; */
  background: rgb(237, 233, 233);
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

#footer a{
  font-size: 1rem;
  text-decoration: none;
}

@media only screen and (max-width:786px){
  #footer a{
    font-size: 0.75rem;
   
  }
  .Container{
    width: 90% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB;gBACc;EACd,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;;EAEpB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody, html {\n  width: 100%;\n  height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n#root {\n  height: 100%;\n}\n\n.wrapper {\n  width: 100%;\n  height: calc(100% - 62px);\n  min-height: 100vh;\n}\n\n.container {\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n}\n\n.btn {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 19px;\n  border-radius: 5px;\n  background: #61AC47;\n  padding: 10px 25px;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  outline: none;\n}\n\n.btn:active, .btn:focus {\n  outline: none;\n  user-select: none;\n}\n\n.btn-inverted {     \n  background: #fff;\n  color: #1f5d23;\n}\n\n.btn-inverted-bordered {\n  border: 1px solid #1f5d23;\n  border-radius: 5px;\n}\n\n.btn-dark {\n  background-image: url(\"./assets/background-rect.png\");\n  text-decoration: none;\n}\n\nbutton:disabled {\n  cursor: not-allowed;\n  opacity: .5;\n}\n\n.error {\n  font-size: 12px;\n  line-height: 14px;\n  color: #D0021B;\n}\n\n.displayNone {\n  display: none !important;\n}\n\n.visibilityHidden {\n  visibility: hidden;\n  /* z-index: -1; */\n}\n\n.minwidth-200 {\n  display: block;\n  width: 250px;\n  margin: 0px auto;\n  text-align: center;\n  position: relative;\n}\n\n#footer{\n  /* position: fixed; */\n  /* position:sticky;\n  bottom: 5px; */\n  background: rgb(237, 233, 233);\n  height: 50px;\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n#footer a{\n  font-size: 1rem;\n  text-decoration: none;\n}\n\n@media only screen and (max-width:786px){\n  #footer a{\n    font-size: 0.75rem;\n   \n  }\n  .Container{\n    width: 90% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
